<template>
    <v-app>
        <v-card tile color="transparent">
            <v-row class="m-3" v-if="data != null" :loading="loading">

                <v-flex class="m-3" sm="12" md="6">
                    <div v-if="data.user_info != null">
                        <request-details :request="data"/>
                    </div>
                    <div v-if="data.bussiness != null">
                        <business :request="data"/>
                    </div>
                </v-flex>

                <v-flex class="m-3" sm="12" md="6">
                    <user-details :details="data"/>
                </v-flex>

            </v-row>

            <v-divider class="mt-4"/>

            <transition name="slide-y-reverse-transition" mode="out-in">
                <v-card-actions class="px-0" v-if="description.model">
                    <!--                @keydown.enter="reject"-->
                    <v-textarea v-model="description.text" label="توضیحات" outlined class="m-3"
                                  :error-messages="errors.description" prepend-icon="mdi-send" append-icon="mdi-close"
                                  @click:append="description.model = false" @click:prepend="reject"/>
                </v-card-actions>
            </transition>

            <v-card-actions class="justify-space-around px-0">
                <v-btn elevation="0" color="primary" large class="flex-50" @click="accept" :loading="loading">
                    <v-icon class="ml-2">mdi-thumb-up</v-icon>
                    تایید
                </v-btn>
                <v-btn elevation="0" color="error" outlined large class="flex-50" :loading="loading"
                       @click="description.model = true">
                    <v-icon class="ml-2">mdi-thumb-down</v-icon>
                    رد کردن
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-app>
</template>

<script>
import UserDetails from "./userInfo/userDetails";
import RequestDetails from "./userInfo/requestDetails";
import Business from "./userInfo/Business";

export default {
    name: "showRequest",
    props: ['id'],

    components: {RequestDetails, UserDetails, Business},

    data: () => ({
        data: null,
        loading: false,
        description: {
            model: false,
            text: '',
        },

        errors: {},
    }),

    mounted() {
        this.fetch();
    },

    methods: {
        fetch() {
            this.loading = true;

            this.requestApiGet(`authRequest/${this.id}`)
                .then(({data}) => this.data = data)
                .catch(({response}) => console.log('error in auth requests: ', response))
                .finally(() => this.loading = false);
        },

        accept() {
            console.log('clicked accept: ');

            this.loading = true;

            this.requestApiPost('authRequest', {
                id: this.id,
                status: 'accept',
            })
                .then(({data}) => {
                    if (data.message != null) this.$toast.success(data.message);
                    else this.$toast.success('موفق');
                    this.$router.replace('/user/confirmed');
                })
                .catch(({response}) => {
                    if (response.data != null && response.data.message != null) this.$toast.error(response.data.message);
                    else this.$toast.error('ناموفق');
                    this.errors = response.data.errors;
                })
                .finally(() => this.loading = false);
        },

        reject() {

            if (this.description.text == null || this.description.text.length <= 0) {
                this.errors.description = ['لطفا توضیحات رد کردن درخواست را در نمایید.'];
                this.$forceUpdate();
                return;
            }
            this.loading = true;

            this.requestApiPost('authRequest', {
                id: this.id,
                status: 'edit',
                description: this.description.text,
            })
                .then(({data}) => {
                    if (data.message != null) this.$toast.success(data.message);
                    else this.$toast.success('موفق');
                    this.$router.replace('/user/confirmed');
                })
                .catch(({response}) => {
                    if (response.data != null && response.data.message != null) this.$toast.error(response.data.message);
                    else this.$toast.error('ناموفق');
                    this.errors = response.data.errors;
                })
                .finally(() => this.loading = false);
        }
    }
}
</script>

<style scoped>
.flex-50 {
    flex: 1 1 50%;
}
</style>
